module.exports = __webpack_public_path__ + "static/media/ic_pagarfatura.269ea621.svg";